require("./bootstrap");
import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import vSelect from "vue-select";
import ".././css/vue-select-luna.css";
import VModal from "vue-js-modal";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import VueSlider from "vue-slider-component";
import ".././css/vue-silder-luna.css";
import Tooltip from "vue-directive-tooltip";
import ".././css/vue-tooltip-luna.css";
import Toasted from "vue-toasted";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import { datadogRum } from "@datadog/browser-rum";
import { initDatadogLogs, initDatadogRum } from "./observability/datadog";
import ToastPlugin from "./plugins/toast";
import GoodIcon from "./Pages/components/Icon/GoodIcon.vue";
import TwitterXIcon from "./Pages/components/Icon/TwitterXIcon.vue";
import RecommendPlanBanner from "./Pages/components/Banner/RecommendPlanBanner/index.vue";

Vue.component("GoodIcon", GoodIcon);
Vue.component("TwitterXIcon", TwitterXIcon);
Vue.component("RecommendPlanBanner", RecommendPlanBanner);
Vue.component("v-select", vSelect);
Vue.component("v-slider", VueSlider);
Vue.use(Croppa);
Vue.use(VModal);
Vue.use(Tooltip, {
    placement: "top",
});
Vue.use(Toasted, {
    theme: "outline",
    iconPack: "material",
    fitToScreen: true,
    position: "top-center",
    duration: 5000,
    singleton: true,
    containerClass: "toast-high-z-index",
});
Vue.use(ToastPlugin);

// Datadog Browser RUM / Logs の初期化（credential 未設定なら no-op）。
// RUM → Logs の順に呼ぶ（ログに session_id / view.id を載せて RUM と相関させるため）。
initDatadogRum();
initDatadogLogs();

Vue.config.errorHandler = function (err, vm, info) {
    console.error(err);

    // Vue が握ったエラーは window.onerror に伝播せず RUM の自動収集から漏れるため、
    // ここから明示的に Datadog RUM へ報告する（未 init なら実質 no-op）。
    datadogRum.addError(err, {
        source: "vue-error-handler",
        url: window.location.href,
        userAgent: navigator.userAgent,
        userLocale: navigator.language,
        vueInfo: info,
    });
};

/**
 * Note: FCMのService Worker設定ファイルをLaravelから取得して提供する
 *       Service Workerから環境変数を読み取れないため、Laravelの設定ファイルから取得した値を埋め込む
 */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/firebase-messaging-sw.js')
            .then((registration) => {
                console.log('Service Worker registered:', registration);
            })
            .catch((error) => {
                console.error('Service Worker registration failed:', error);
            });
    });
}

new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App />", // ルートコンポーネントを描画する
});
